import React, {Component} from 'react';

export default class AddNewLink extends Component {

    handleNewLink = (evt) => {
        if (evt.key === "Enter") {
            this.props.http.addLink(this.props.categoryId, this.newLink.value, this.props.addToCategory);
            this.newLink.value = ""
        }
    };

    render() {
        return (
            <tr className="acceptableElement">
                <td style={{textAlign: "center", padding: "0", margin: "0"}}>
                    <input type="text" width="100%" placeholder="Add new link"
                           style={{padding: "8px 20px", border: "0", backgroundColor: "transparent", width: "100%"}}
                           ref={(input) => {this.newLink = input;}}
                           onKeyPress={this.handleNewLink}
                    />
                </td>
            </tr>
        )
    }

}

AddNewLink.propTypes = {
    categoryId: React.PropTypes.number.isRequired,
    addToCategory: React.PropTypes.func.isRequired,
    http: React.PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/dashboard/links/AddNewLink.js